module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av576-1c9d4017c45781d177e6f8d2f8f661f2.jpg";